import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function VerifyCard() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/player/login", { replace: true }); }, []);
  return null;
}
